import "../App.css";
import Hamburger from 'hamburger-react';
import { useState } from "react";
import { Link } from 'react-scroll'


export function Navbar() {
    const [isOpen, setOpen] = useState(false);
    const [colorChange, setColorchange] = useState(false);
    const changeNavbarColor = () => {
        if (window.scrollY >= 200) {
            setColorchange(true);
        }
        else {
            setColorchange(false);
        }
    };
    window.addEventListener('scroll', changeNavbarColor);
    return <div className={colorChange ? "navbar trans" : "navbar"}>
        <a className="links" id="bigger" href="#home">&lt; <b>RvSingh</b> /&gt; </a>
        <div id="linkMin">
            <a className="links" href="#about"><Link activeClass="active" className="test1" to="Abouts" spy={true} smooth={true} duration={500} >About</Link></a>
            <a className="links" href="#projects"><Link activeClass="active" className="test1" to="Projects" spy={true} smooth={true} duration={500} >Projects</Link></a>
            <a className="links" href="#skills"><Link activeClass="active" className="test1" to="Skills" spy={true} smooth={true} duration={500} >Skills</Link></a>

            <a className="links" target="_blank" rel="noreferrer" href="https://drive.google.com/file/d/1FAU3Mk7vYeSK_wtdEPFdufGXnC3fh02k/view?usp=sharing">Resume</a>
        </div>
        <div className="hamburger">

            <Hamburger toggled={isOpen} toggle={setOpen} />
        </div>
        <div id={isOpen ? "whiteBack" : "whiteBac"}></div>

        <div id={isOpen ? "newOne" : "newOneDis"}>
            <a className="links" href="#about"><Link activeClass="active" className="test1" to="Abouts" spy={true} smooth={true} duration={500} >About</Link></a>
            <a className="links" href="#projects"><Link activeClass="active" className="test1" to="Projects" spy={true} smooth={true} duration={500} >Projects</Link></a>
            <a className="links" href="#skills"><Link activeClass="active" className="test1" to="Skills" spy={true} smooth={true} duration={500} >Skills</Link></a>

            <a className="links" target="_blank" rel="noreferrer" href="https://drive.google.com/file/d/1FAU3Mk7vYeSK_wtdEPFdufGXnC3fh02k/view?usp=sharing">Resume</a>
        </div>
    </div>
}
